import { render, staticRenderFns } from "./OffersListContent.vue?vue&type=template&id=2b69b1bb"
import script from "./OffersListContent.vue?vue&type=script&lang=js"
export * from "./OffersListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports